import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';


// Inputs
import { CheckboxField, TextInputField } from '../helpers';

// utils
import { round } from '../utils';

// constants
import { DECIMAL_LIMIT } from '../constants';

// Redux inputs
import { raiseToast } from '../services/redux/reducers/toast/toast';



const ReplaceBuyerReqItems = (props) => {
    const dispatch = useDispatch()
    const { buyerReqItem, displayLabel, selectedReplaceBuyerReqItemIds, replaceBuyerReqItems } = props

    const handleSelectReplaceBuyerReq = (event, selectedBuyerReqItemId) => {
        let relatedBuyerReqItemIds = []
        if(selectedReplaceBuyerReqItemIds.includes(selectedBuyerReqItemId)){
            relatedBuyerReqItemIds = selectedReplaceBuyerReqItemIds.filter(eachBuyerReqItemId => eachBuyerReqItemId !== selectedBuyerReqItemId)
        }
        else{
            relatedBuyerReqItemIds = [...selectedReplaceBuyerReqItemIds, selectedBuyerReqItemId]
        }
        props.setSelectedInvoiceDispatchNotesIds(relatedBuyerReqItemIds)
    }

    const handleReplaceBuyerReqItemQtyChange = (event, selectedBuyerReqItemId) => {
        let relatedReplaceBuyerItem = replaceBuyerReqItems.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === selectedBuyerReqItemId)
        if(relatedReplaceBuyerItem){
            if(event.target.value > relatedReplaceBuyerItem.totalQty){
                return dispatch(raiseToast({severity:'warn', detail: `Enter quantity not more than ${relatedReplaceBuyerItem.totalQty}`, life: 3000}))
            }
            relatedReplaceBuyerItem.qty = event.target.value
            relatedReplaceBuyerItem.totalAmount = round(relatedReplaceBuyerItem.qty * relatedReplaceBuyerItem.unitPrice, DECIMAL_LIMIT)
        }

        props.setReplaceBuyerReqItems([...replaceBuyerReqItems])
    }

    let relatedReplacedBuyerReqItem = null

    let relatedReplaceBuyerReqItem = replaceBuyerReqItems.find(eachBuyerReqItem => eachBuyerReqItem.replacedBuyerReqItems && eachBuyerReqItem.replacedBuyerReqItems.length > 0)
    if(relatedReplaceBuyerReqItem){
        relatedReplacedBuyerReqItem = relatedReplaceBuyerReqItem?.replacedBuyerReqItems?.find(eachBuyerReqItem => eachBuyerReqItem.buyerReqItemId === buyerReqItem.buyerReqItemId)
    }
    let productName = buyerReqItem?.companyProdName ? buyerReqItem?.companyProdName : buyerReqItem?.productName
    let productSpecification = buyerReqItem?.companyProdSpec ? buyerReqItem?.companyProdSpec : buyerReqItem?.productSpecification

    console.log("buyerReqItem", buyerReqItem)
    console.log("relatedReplaceBuyerReqItem", relatedReplaceBuyerReqItem)

    return(
        <div key={`buyerReqItem-${buyerReqItem.buyerReqItemId}`} className="grid align-items-center">
            <div className="flex col-12 lg:col-6">
            	<div className="flex" style={{width: '35px'}} >
                    <CheckboxField 
                        className="col" 
                        onChange={(e) => handleSelectReplaceBuyerReq(e, buyerReqItem.buyerReqItemId)} 
                        checked={selectedReplaceBuyerReqItemIds.includes(buyerReqItem.buyerReqItemId)} 
                        disabled={buyerReqItem.replacedBuyerReqItems} // || relatedReplaceBuyerReqItem
                    />
                </div>
                <div className="col" style={{flexGrow: 1}}>
                    <p className="m-0" style={{fontSize: '12px'}}>
                        {productName} | {productSpecification} | {buyerReqItem?.UOM}
                    </p>
                    <p className="m-0 text-sm seller-name" style={{fontSize: '12px'}}></p>
                </div>
            </div>
            <div className="flex col-12 lg:col-6">
                <div className="grid">
                    <div className="flex flex-column col-12 lg:col-3">
                        <TextInputField name="unitPrice" value={buyerReqItem.unitPrice} labelText={displayLabel && "Unit Price"} keyfilter="pnum" disabled />
                    </div>
                    <div className="flex flex-column col-12 lg:col-3">
                        <TextInputField name="Quantity" value={buyerReqItem.totalQty} labelText={displayLabel && "Total Quantity"} disabled />
                    </div>
                    <div className="flex flex-column col-12 lg:col-3">
                        <TextInputField 
                            name="Quantity" 
                            value={buyerReqItem.qty} 
                            keyfilter='pnum' 
                            labelText={displayLabel && "Quantity"} 
                            onChange={(event)=>handleReplaceBuyerReqItemQtyChange(event, buyerReqItem.buyerReqItemId)}
                            disabled={buyerReqItem.replacedBuyerReqItems}
                        />
                    </div>
                    <div className="flex flex-column col-12 lg:col-3">
                        {/*<TextInputField name="totalAmount" value={round(buyerReqItem.qty * buyerReqItem.unitPrice)} labelText={displayLabel && "Total Amount"} disabled/> */}
                        <TextInputField name="totalAmount" value={buyerReqItem.totalAmount} labelText={displayLabel && "Total Amount"} disabled/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReplaceBuyerReqItems

